var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky"},[_c('UserNotification',{attrs:{"userNotification":_vm.lastNotification,"showDelete":true},on:{"delete":_vm.updateUserNotificationDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }